import { Box, Center, HStack, Image, Pressable, Text, VStack } from "native-base";
import React, { useState } from "react";

import IfeiraLogo from "@/assets/icons/secondary_icon.png";
import HomeBackground from "@/assets/svgs/HomeBackgroud";
import SearchInput from "@/components/atoms/SearchInput";
import AppStatusBar from "@/components/atoms/StatusBar";
import ClickProtectedWrapper from "@/components/molecules/ClickProtectedWrapper";
import HeaderAddressButton from "@/components/molecules/HeaderAddressButton";
import SacButton from "@/components/molecules/SacButton";
import Container from "@/components/organisms/Container";
import PromotionList from "@/components/organisms/PromotionList";
import StoreList from "@/components/organisms/StoreList";
import StoreTypesList from "@/components/organisms/StoreTypesList";
import WelcomeModal from "@/components/organisms/WelcomeModal";
import { useViewport } from "@/contexts/ViewportContext";
import { useAppNavigation } from "@/hooks/application/navigation";
import { RootNavigation } from "@/navigation/Root";

import { HomeProps } from "./types";

const HomeMobile = ({
  promotionList,
  isLoadingPromotionList,
  storeTypeList,
  isLoadingStoreTypeList,
  storeList,
  isLoadingStoreList,
  onLoadMoreStores,
  onSelectStoreType,
  onSelectStore,
}: HomeProps) => {
  const { navigateBetweenStacks } = useAppNavigation<RootNavigation>();
  const { width, height } = useViewport();

  const [modalVisible, setModalVisible] = useState(false);

  return (
    <>
      <Container px="0" pt="0" pb="16">
        <AppStatusBar isSecondaryBg />
        <ClickProtectedWrapper onPress={() => setModalVisible(true)}>
          <VStack w="100%" pb="12" bgColor="transparent">
            <Box position="absolute" top="0" left="0" zIndex={-1} bgColor="secondary.400">
              <HomeBackground width={width} height={height} />
            </Box>
            <VStack w="100%" padding="4" zIndex={1} bgColor="transparent">
              <HStack justifyContent="space-between" alignItems="center">
                <HeaderAddressButton />
                <Box>
                  <SacButton floatMode={false} />
                </Box>
              </HStack>
              <Center my="8">
                <Image
                  source={IfeiraLogo}
                  resizeMode="contain"
                  w="40%"
                  h="80px"
                  alt="ifeira logo"
                />
                <Pressable
                  w="full"
                  pointerEvents="box-only"
                  onPress={() => navigateBetweenStacks("search")}>
                  <SearchInput h="58px" mt="10" fontSize="lg" editable={false} />
                </Pressable>
              </Center>
            </VStack>
            <Center>
              <StoreTypesList
                storeTyes={storeTypeList}
                isLoading={isLoadingStoreTypeList}
                onSelectType={onSelectStoreType}
              />
            </Center>
            <Center>
              <Text fontSize="2xl" color="text.600" bold mt="4" p="2">
                Promoções
              </Text>
            </Center>
            <PromotionList data={promotionList} isLoading={isLoadingPromotionList} />
            <Center>
              <Text fontSize="2xl" color="text.600" bold my="4" p="2">
                Lojas disponíveis
              </Text>
            </Center>
            <StoreList
              data={storeList}
              isLoading={isLoadingStoreList}
              onLoadMore={onLoadMoreStores}
              onSelect={onSelectStore}
            />
          </VStack>
        </ClickProtectedWrapper>
      </Container>
      <WelcomeModal modalVisible={modalVisible} onClose={() => setModalVisible(false)} />
    </>
  );
};

export default HomeMobile;
